import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import config from "../../Config";
import StudentRightsCheck from "./StudentRightsCheck";
import StudentPanelMenu from "./StudentPanelMenu";

function StudentPanelSyllabusDownload() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(parseInt(localStorage.getItem("ID"), 10) || 0);
  const [MemberType] = useState(localStorage.getItem("MemberType") || "Student");
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [className, setClassName] = useState("");

  useEffect(() => {
    document.title = "Syllabus Download - Student Panel";
    axios({
      method: "post",
      url: config.base_url + "ClassSyllabus/GetMyClassSyllabusFiles",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, Student_ID: UserID },
    })
      .then((res) => {
        if (res.data && res.data.status_code === 1) {
          setRows(res.data.ListofRecords || []);
          setClassName(res.data.Class_Name || "");
        } else {
          setRows([]);
          setClassName("");
        }
      })
      .catch(() => {
        setRows([]);
        setClassName("");
      })
      .finally(() => setLoading(false));
  }, []);

  const fileUrl = (fileName) =>
    `${config.root}ClassSyllabus/${encodeURIComponent(fileName || "")}`;

  return (
    <>
      <StudentPanelMenu />
      <StudentRightsCheck />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/student-panel/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Syllabus Download</li>
                  </ol>
                </nav>
                <div className="page-title">Syllabus Download</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container body-content">
        <div className="card">
          <div className="card-body">
            {loading ? (
              <Spinner animation="border" role="status" />
            ) : rows.length === 0 ? (
              <p className="text-muted mb-0">No syllabus files available for your class right now.</p>
            ) : (
              <>
                {className ? (
                  <p className="mb-3">
                    <strong>Class:</strong> {className}
                  </p>
                ) : null}
                <div className="table-responsive">
                  <table className="table table-theme table-hover">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>File</th>
                        <th>Details</th>
                        <th>Updated On</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((r) => (
                        <tr key={r.ID}>
                          <td>{r.ID}</td>
                          <td>{r.SyllabusFileAttached || "-"}</td>
                          <td>{r.SyllabusDetails || "-"}</td>
                          <td>
                            {r.LastUpdated
                              ? String(r.LastUpdated).replace("T", " ").substring(0, 19)
                              : r.Updated_Date
                              ? String(r.Updated_Date).replace("T", " ").substring(0, 19)
                              : "-"}
                          </td>
                          <td className="text-center">
                            {r.SyllabusFileAttached ? (
                              <a
                                href={fileUrl(r.SyllabusFileAttached)}
                                target="_blank"
                                rel="noreferrer"
                                download={r.SyllabusFileAttached}
                                className="button button-primary button-sm"
                              >
                                Download
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentPanelSyllabusDownload;
